// extracted by mini-css-extract-plugin
export default {"FormConsent":"ConsentExperience-module__FormConsent--tY15x","FormConsentNotice":"ConsentExperience-module__FormConsentNotice--vKqK0"};